export default __webpack_public_path__ + "static/media/s0_female.a955b800.wav";